export default __webpack_public_path__ + "static/screeny-85-gpz-s-5-abe283a8e8ba3ce4de1e3de815f2caa0.jpg";